import classNames from 'classnames'
import { ArrowDown, ArrowUp, ChevronsUpDown } from 'lucide-react'

import React from 'react'

import { TableSorting } from '@/hooks/ui'

export type SortingControl<Column> = TableSorting<Column>['control']

interface DataTableSortingProps<Column> {
  control: SortingControl<Column>
  column: Column
  activeColor?: boolean
}

function DataTableSorting<Column>(props: Readonly<DataTableSortingProps<Column>>) {
  const {
    control: { sortingColumns, setSort, getColumnSortValue },
    column,
    activeColor = true,
  } = props

  const sort = getColumnSortValue(column)

  const toggleSort = () => {
    if (sort === 'asc') {
      setSort(column, 'desc')
    } else if (sort === 'desc') {
      setSort(column, null)
    } else {
      setSort(column, 'asc')
    }
  }

  const label = sort === 'asc' ? 'Sorted ascending' : sort === 'desc' ? 'Sorted descending' : 'Sort'
  return (
    <button
      type="button"
      aria-label={label}
      title={label}
      className={classNames(
        'flex-none rounded-sm p-0.5 outline-none hover:bg-fill hover:text-ink focus-visible:ring-2 focus-visible:ring-ring',
        sort && activeColor ? 'text-ink' : 'text-faint'
      )}
      onClick={() => toggleSort()}
    >
      {sort === 'asc' ? (
        <ArrowUp className="size-3.5" aria-hidden="true" />
      ) : sort === 'desc' ? (
        <ArrowDown className="size-3.5" aria-hidden="true" />
      ) : (
        <ChevronsUpDown className="size-3.5" aria-hidden="true" />
      )}
    </button>
  )

}

export { DataTableSorting }
